import { CanActivateFn } from '@angular/router';

import { sessionGuard } from '@/core/auth/guards/session.guard';

/**
 * Restores the session but never blocks. For the not-found page: it renders for anyone, and only
 * needs to know whether there is a session so its "back home" button can pick a destination. A
 * failed restore is not a reason to send the visitor to login — a wrong URL is still a wrong URL.
 */
export const restoreSessionGuard: CanActivateFn = sessionGuard(
  () => true,
  () => true,
);
